var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.58885 0 8.00005C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8.00005C16 3.58885 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8.00005C1.45455 4.39088 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39088 14.5455 8.00005C14.5455 11.6092 11.6092 14.5455 8 14.5455Z",
    fill: "#C1CEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 3.39453C7.46518 3.39453 7.03027 3.82973 7.03027 4.36466C7.03027 4.89911 7.46518 5.33393 7.99978 5.33393C8.53437 5.33393 8.96928 4.89911 8.96928 4.36466C8.96928 3.82973 8.53437 3.39453 7.99978 3.39453Z",
    fill: "#C1CEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 6.78906C7.59809 6.78906 7.27246 7.11469 7.27246 7.51634V11.88C7.27246 12.2816 7.59809 12.6072 7.99973 12.6072C8.40138 12.6072 8.72701 12.2816 8.72701 11.88V7.51634C8.72701 7.11469 8.40138 6.78906 7.99973 6.78906Z",
    fill: "#C1CEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ec2c746b51fb1b529c8479fd88ca1959.svg";
export { ForwardRef as ReactComponent };